export default function getRootVdirName(location: Location): string {
    let rootVdirName: string = null;
    let subPaths = location.pathname.split('/');
    if (subPaths.length >= 2 && subPaths[1] != '') {
        rootVdirName = subPaths[1].toLowerCase();
    }

    return rootVdirName;
}
